(function ($, Drupal) {
  Drupal.behaviors.myModuleBehavior = {
    attach: function (context, settings) {
      // Mobile navigation bar.
      $('.block-superfishalcon-header-menu > .mobile-icon a').unbind().click(function (e) {
        if ($('.block-superfishalcon-header-menu').hasClass('open')) {
          if ($('body').find('.ui-widget-overlay.ui-front').length > 0) {
            setTimeout(function(){
              $('.ui-widget-overlay.ui-front').css('display', 'block');
            },800);
            if ($('body').find('.video--popup').length > 0) {
              $('.video--popup').css('display', 'block');
            }
          }
          $('.block-superfishalcon-header-menu').removeClass('open');
          $('#pg__c').removeClass('open');
        } else {
          if ($('body').find('.ui-widget-overlay.ui-front').length > 0) {
            $('.ui-widget-overlay.ui-front').css('display', 'none');
            if ($('body').find('.video--popup').length > 0) {
              $('.video--popup').css('display', 'none');
            }
          }
          $('.block-superfishalcon-header-menu').addClass('open');
          $('#pg__c').addClass('open');
        }
      });
      $('.block-superfishalcon-header-menu .slide_out_area_close').click(function () {
        if ($('body').find('.ui-widget-overlay.ui-front').length > 0) {
          setTimeout(function(){
            $('.ui-widget-overlay.ui-front').css('display', 'block');
          },800);
          if ($('body').find('.video--popup').length > 0) {
            $('.video--popup').css('display', 'block');
          }
        }
        $('.block-superfishalcon-header-menu').removeClass('open');
        $('#pg__c').removeClass('open');
      });
      fnMobileMenu();

      // Scroll bar functionality.
      $(window).scroll(function () {
        var scrollBottom = $(document).height() - $(window).height() - $(window).scrollTop();
        if ($(document).scrollTop() > 300) {
          $('.region.region-header').addClass('scroll');
          $('#header').addClass('head-scroll');
          $('#to-top').addClass('show');
        }
        else {
          $('.region.region-header').removeClass('scroll');
          $('#header').removeClass('head-scroll');
          $('#to-top').removeClass('show');
        }
        if(scrollBottom > 60){
          $('#to-top').addClass('light');
        }
        else{
          $('#to-top').removeClass('light');
        }
      });

      // Scroll to Top functionlity.
      $('#to-top').click(function(){
        $("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
      });

      // News landing page click event.
      $('.container-video > div.view-content .views-row:first .news-content-main-block').addClass('active');
      $('.view-alcon-news-view.view-display-id-attachment_1 .view-content .views-row:first ul li.news-title').addClass('active');

      // Click event for news page.
      $('.view-alcon-news-view .news-title').on('click', function () {
        var nid = $(this).attr('nid');
        $('.news-content-main-block').removeClass('active');
        $('.news-'+nid).addClass('active').fadeIn(200);
        $(this).parent().parent().parent().parent().siblings().find('li.news-title.active').removeClass('active');
        $(this).addClass('active');
      });

      // Video pop-up on click.
      $('.video--btn button').on('click', function () {
        if ($('body').find('.ui-dialog.video--popup').length > 0) {
          $('body .ui-dialog.video--popup').each(function() {
            $(this).remove();
          });
        }
        var paragraphid = $(this).attr('paragraph');
        // Open video pop-up.
        $('#watch-video-'+paragraphid).dialog({
          modal: true,
          closeOnEscape: false,
          clickOutside: true,
          dialogClass: 'video--popup',
          draggable: false,
          resizable: true,
          overlay: {
            backgroundColor: '#000000',
            opacity: 0.9
          },
          width: 'auto',
          maxWidth: '1000px',
          close: function() {
            var iframe =  $('#watch-video-'+paragraphid).find("iframe");
            iframe.attr("src", iframe.attr("src"));
          }
        });
      });

      //Scientific publication toogle functionality.
      $('.info').hide();
      $(".pub_content").unbind().click(function (e) {
        $(this).parent().parent().parent().parent().siblings().find('.pub_content .info').css('display', 'none');
        $(this).find('.info').slideToggle();
      });

      //To place the clear filter button to top of the filter category.
      $('#views-exposed-form-scientific-publication-view-block-1 .form-actions').insertBefore("details");
      $('#views-exposed-form-scientific-publication-view-block-2 .form-actions').insertBefore("details");
      $('#views-exposed-form-scientific-publication-view-block-3 .form-actions').insertBefore("details");
      $('#views-exposed-form-scientific-publication-view-block-4 .form-actions').insertBefore("details");

      // Reset Filter button
      $('.bef-exposed-form .form-actions.js-form-wrapper.form-wrapper').hide();
      $('.form-item.js-form-type-checkbox').each(function () {
        if ($(this).find('input').is(':checked')) {
          $('.bef-exposed-form .form-actions.js-form-wrapper.form-wrapper').show();
        }
      });

      // News Thumbnail popup.
      $('.news-left-wrapper .field--name-field-news-thumbnail img').on('click', function() {
        $('.thumbnail-popup').dialog({
          modal: true,
          closeOnEscape: false,
          clickOutside: true,
          dialogClass: 'news-img--popup',
          draggable: false,
          resizable: true,
          overlay: {
            backgroundColor: '#000000',
            opacity: 0.9
          },
          width: 'auto',
          maxWidth: '600px',
          close: function() {
          }
        });
      });
    }
  };

  //antispam
  $.fn.myFunction = function(){
    if ($('#antiSpam')) {
      var a = $('#antiSpam');
      if (isNaN(a.val()) == true){
        a.val(0);
      }
      else {
        a.val(parseInt(a.val()) + 1);
      }
    }
    setTimeout($.fn.myFunction, 1000);
  }
  $.fn.myFunction();

  // Mobile menu sub menu items.
  var fnMobileMenu = function(){
    if($(window).width() <= 1350) {
      $('#superfish-alcon-header-menu a.menuparent + ul').addClass('sf-hidden');
      if ($('#superfish-alcon-header-menu a.menuparent + ul').find('li.back').length == 0) {
        $('#superfish-alcon-header-menu a.menuparent + ul').prepend('<li class="back"><a href="#">' + $(".closed").data("backtext") + '</a></li>');
      }
      $('#superfish-alcon-header-menu a.menuparent').on('click', function (e) {
        if($(window).width() <= 1350) {
          e.preventDefault();
          $(this).parent().siblings().hide(500);
          $(this).hide(500);
          $(this).parent().addClass('open');
          $(this).closest("li").find("ul.sf-hidden").removeClass('sf-hidden');
        }
      });
      $('#superfish-alcon-header-menu .back a').on('click', function (e) {
        if($(window).width() <= 1350) {
          $(this).closest("ul").siblings().show(500);
          $(this).closest("ul").siblings().parent().siblings().show(500);
          $(this).closest("ul").addClass('sf-hidden');
          $(this).closest("ul").parent().removeClass('open');
        }
      });
    }
    else {
      $('#superfish-alcon-header-menu a.menuparent .back').remove();
      $('#superfish-alcon-header-menu a.menuparent + ul').removeClass('sf-hidden');
    }
  }
  $(window).on('resize',function () {
    fnMobileMenu();
  });

  $(window).on('resize',function () {
    var length =  $('body').find('.ui-dialog.video--popup .hero-banner__media-thumbnail iframe').length;
    if (length > 0) {
      var winwidth = $(window).width();
      if (winwidth < 768) {
        $('body .ui-dialog.video--popup').addClass('video--popup-rotation');
      }
      else {
        $('body .ui-dialog.video--popup').removeClass('video--popup-rotation');
      }

      if (winwidth >= 768) {
        $('body .ui-dialog.video--popup').addClass('video--popup-rotation-ipad');
      }
      else {
        $('body .ui-dialog.video--popup').removeClass('video--popup-rotation-ipad');
      }

    }
    else {
      $('body .ui-dialog.video--popup').removeClass('video--popup-rotation');
    }
  });

  // Share IT functionality.
  var $socialTimeout;
  $('body').on('mouseenter', '.addtoany-btn', function() {
    clearTimeout($socialTimeout);
    var $addToAnyList = $(this).find(".addtoany_list");
    $addToAnyList.show().stop(true).animate({
      'opacity': 1,
      'right': '0px'
    }, 0);
    $(this).closest('.like-share-wrap').addClass('social-hovered');
    $(this).closest('.like-share-wrap').find('.shareit, .like-btn').stop(true).animate({
      'opacity': 0
    }, 250);
    $addToAnyList.find('a').each(function(i) {
      $(this).stop(true).delay(i * 40).animate({
        'opacity': 1,
        'left': '0px'
      }, 150);
    });
  });

  $('body').on('mouseleave', '.addtoany-btn', function() {
    $(this).closest('.like-share-wrap').removeClass('social-hovered');
    var $addToAnyList = $(this).find(".addtoany_list");
    $addToAnyList.stop(true).animate({
      'opacity': 0,
      'right': '-20px'
    }, 200);

    $(this).closest('.like-share-wrap').find('.shareit, .like-btn').stop(true).animate({
      'opacity': 1
    }, 250);

    var $that = $(this);
    $socialTimeout = setTimeout(function() {
      $that.find('.addtoany_list').hide();
      $that.find('.addtoany_list a').stop(true).animate({
        'opacity': 0,
        'left': '20px'
      }, 0);
    }, 0);
  });

  // Like button for News details.
  var count = $('.like-share-wrap .likeit-count').text();
  var res = count.split(" ");
  var like = res[0];
  if (res[0] == '') {
    var like = res[1];
  }
  $('.like-share-wrap .likeit-count').text(like);
  // Title for Like button.
  if ($('.like-share-wrap').find('.likeit-wrapper > a').length > 0) {
    $('.like-share-wrap').find('.likeit-wrapper .likeit-count').attr('title', 'Love this');
  }
  else {
    $('.like-share-wrap').find('.likeit-wrapper .likeit-count').attr('title', 'You already love this!');
  }

  // Like button for News teaser.
  $(".view-display-id-page_1 > div.view-content .views-row").each(function() {
    var likeCount = $(this).find('.likeit-count').text();
    var response = likeCount.split(" ");
    var like = response[0];
    if (response[0] == '') {
      var like = response[1];
    }
    $(this).find('.likeit-count').text(like);

    // Title for Like button.
    if ($(this).find('.likeit-wrapper > a').length > 0) {
      $(this).find('.likeit-wrapper .likeit-count').attr('title', 'Love this');
    }
    else {
      $(this).find('.likeit-wrapper .likeit-count').attr('title', 'You already love this!');
    }
  });

  // Event that trigger after ajax complete.
  $(document).ajaxComplete(function() {
    if ($('body').find('.likeit-wrapper').length > 0) {
      // Like button for News details.
      var count = $('.like-share-wrap .likeit-count').text();
      var res = count.split(" ");
      var like = res[0];
      if (res[0] == '') {
        var like = res[1];
      }
      $('.like-share-wrap .likeit-count').text(like);

      // Like button for News teaser.
      $(".view-display-id-page_1 > div.view-content .views-row").each(function() {
        var likeCount = $(this).find('.likeit-count').text();
        var response = likeCount.split(" ");
        var like = response[0];
        if (response[0] == '') {
          var like = response[1];
        }
        $(this).find('.likeit-count').text(like);

        // Title for Like button.
        if ($(this).find('.likeit-wrapper > a').length > 0) {
          $(this).find('.likeit-wrapper .likeit-count').attr('title', 'Love this');
        }
        else{
          $(this).find('.likeit-wrapper .likeit-count').attr('title', 'You already love this!');
        }
      });
    }
  });
  
  //validate phone number in contact form.
  $("#contact-form .form-submit, #medical-affairs-contact-form .form-submit, #china-medical-affairs-contact-form .form-submit").click(function (event) {
    var phone = jQuery('#edit-phone').val();
    if(phone){
      var regex = /((\+\d{1,3}(-|.| )?\(?\d\)?(-| |.)?\d{1,5})|(\(?\d{2,6}\)?))(-|.| )?(\d{3,4})(-|.| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;
      if (!regex.test(phone)) {
        $('#phone-err').html('Phone number is Invalid');
        $('#phone-err').show();
        event.preventDefault();
      }
      else{
        $('#phone-err').hide();
      }
    }
  });

  // Description pop-up on click.
  $('.popup-link-text').on('click', function () {
    if ($('body').find('.ui-dialog.popup--description').length > 0) {
      $('body .ui-dialog.popup--description').each(function () {
        $(this).remove();
      });
    }
    var pid = $(this).attr('paragraph');
    // Open Description pop-up.
    $('#popup-link-' + pid).dialog({
      modal: true,
      closeOnEscape: false,
      clickOutside: true,
      dialogClass: 'popup--description',
      draggable: false,
      resizable: true,
      overlay: {
        backgroundColor: '#000000',
        opacity: 0.9
      },
      width: 'auto',
      maxWidth: '100%',
      close: function close() {
      }
    });

    if ($('.ui-widget-overlay').length > 0) {
      $('.ui-widget-overlay').append('<span class="pop-close cross-icon" paragraph="'+pid+'"></span>');
    }
  });

  // Close popup for Link.
  $('body').on('click', '.pop-close', function(){
    var pid = $(this).attr('paragraph');
    $('#popup-link-' + pid).dialog('close');
  });

  // Heading Pop-up functionality.
  if ($('#heading-pop-up').parent().parent().parent().siblings().find('.popup--desc').length > 0) {
    $('#heading-pop-up').on('click', function (event) {
      event.preventDefault();
      if ($('body').find('.ui-dialog.popup--description').length > 0) {
        $('body .ui-dialog.popup--description').each(function () {
          $(this).remove();
        });
      }
      // Open Description pop-up.
      $('.popup--desc').dialog({
        modal: true,
        closeOnEscape: false,
        clickOutside: true,
        dialogClass: 'popup--description',
        draggable: false,
        resizable: true,
        overlay: {
          backgroundColor: '#000000',
          opacity: 0.9
        },
        width: 'auto',
        maxWidth: '100%',
        close: function close() {}
      });

      if ($('.ui-widget-overlay').length > 0) {
        $('.ui-widget-overlay').append('<span class="pop-close pop-close-heading cross-icon"></span>');
      }
    });
  }
  // Close popup for heading.
  $('body').on('click', '.pop-close-heading', function(){
    $('.popup--desc').dialog('close');
  });

})(jQuery, Drupal);
